<template>
    <div v-if="filteredAdditionalCosts.length" class="flex flex-col gap-3 border-t border-gray-200 p-6">
        <ul class="flex flex-col gap-3">
            <li v-for="(cost, index) in filteredAdditionalCosts" :key="index" class="flex justify-between">
                <span class="flex items-center gap-2 text-left text-base font-bold">
                    <Icon :icon="cost.icon" class="fill-black text-xl" :auto-align="false" />
                    <span>
                        {{ cost.label }}
                    </span>
                </span>
                <template v-if="context === 'cart' && cartDebugMode && (isCheckoutPath(route.path) || isMenuPath(route.path))">
                    <div class="flex flex-col items-end">
                        <span
                            class="text-right text-base font-bold tabular-nums"
                            :class="cost.value !== cart().getAdditionalCostsLocal[cost.name] ? 'text-red-500' : 'text-green-500'"
                        >
                            CL: {{ currencyFormat(cart().getAdditionalCostsLocal[cost.name] || 0) }}
                        </span>
                        <span
                            class="text-right text-base font-bold tabular-nums"
                            :class="cost.value !== cart().getAdditionalCostsVerified[cost.name] ? 'text-red-500' : 'text-green-500'"
                        >
                            CS: {{ currencyFormat(cart().getAdditionalCostsVerified[cost.name] || 0) }}
                        </span>
                    </div>
                </template>
                <template v-else>
                    <span
                        v-if="cost.value > 0"
                        class="font-bold tabular-nums"
                    >
                        {{
                            currencyFormat(cost.value)
                        }}
                    </span>
                    <span
                        v-else-if="cost.value === 0"
                        class="text-right text-base font-bold tabular-nums"
                    >
                        {{ $t('cart.costs.free') }}
                    </span>
                </template>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    import IconDelivery from '~/assets/icons/delivery.svg'
    import IconDeposit from '~/assets/icons/deposit.svg'
    import IconPackaging from '~/assets/icons/packaging.svg'
    import IconPayment from '~/assets/icons/payment.svg'
    import IconTip from '~/assets/icons/tip.svg'
    import Icon from '~/components/Icon.vue'
    import { cart } from '~/store/cart'
    import { checkout } from '~/store/checkout'
    import { isCheckoutPath, isMenuPath } from '~/utils/path-utils'
    // TODO: Make TS definitions for the props
    interface AdditionalCost {
        additionalCost?: any
        dispatchType?: any
        context?: 'cart' | 'receipt'
    }
    const props = withDefaults(defineProps<AdditionalCost>(), {
        context: 'cart' // cart | receipt
    })
    const route = useRoute()
    const { t } = useI18n()
    const dispatchType = computed(() => props.dispatchType || checkout()?.input?.dispatchType)
    const filteredAdditionalCosts = computed(() => {
        return [
            {
                name: 'delivery',
                label: t('cart.costs.delivery'),
                value: props.additionalCost?.delivery,
                icon: IconDelivery
            },
            {
                name: 'payment',
                label: t('cart.costs.payment'),
                value: props.additionalCost?.payment,
                icon: IconPayment
            },
            {
                name: 'tip',
                label: t('cart.costs.tip'),
                value: props.additionalCost?.tip,
                icon: IconTip
            },
            {
                name: 'packaging',
                label: t('cart.costs.packaging'),
                value: props.additionalCost?.packaging,
                icon: IconPackaging
            },
            {
                name: 'deposit',
                label: t('cart.costs.deposit'),
                value: props.additionalCost?.deposit,
                icon: IconDeposit
            }
        ].filter(additionalCostsItem =>
            additionalCostsItem.value !== undefined && (additionalCostsItem.value > 0 || (additionalCostsItem.name === 'delivery' && dispatchType.value !== 'PICK_UP'))
        )
    })
    const { public: { cartDebugMode } } = useRuntimeConfig()
</script>
